// extracted by mini-css-extract-plugin
export default {"container":"J1-z","heading":"K1-z","links":"L1-z","copy":"M1-z","subCopy":"N1-z","linksLeft":"O1-z","linksCenter":"P1-z","linksRight":"Q1-z","link":"R1-z","onlyLink":"S1-z"};